import React, { useRef, useState } from "react";
import "./profile.scss";
import useProfileUtils from "./profileUtils.js";
import { TitleHeader } from "../../components/index.js";
import OverlayLoading from "../../common/OverlayLoader/Overlayloader.js";
import { EyeClosedIcon, EyeOpenIcon } from "../../icon/icons.jsx";



const Profile = () => {
  const breadcrumbs = [
    { label: "Profile", link: "" },
    { label: "Edit Profile", link: "" },
  ];

  const {
    formData,
    loading,
    handleFormChange,
    submitForm,
    formErrors,
    setFormData,
  } = useProfileUtils();

  const [selectedImage, setSelectedImage] = useState(null);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const inputRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));
      setSelectedImage(imageUrl);
    }
  };

  const togglePassword = (field) => {
    switch (field) {
      case "current":
        setShowCurrentPassword(!showCurrentPassword);
        break;
      case "new":
        setShowNewPassword(!showNewPassword);
        break;
      case "confirm":
        setShowConfirmPassword(!showConfirmPassword);
        break;
      default:
        break;
    }
  };

  const handlePasswordToggle = () => {
    setFormData((prev) => {
      if (prev.changePassword) {
        return {
          ...prev,
          changePassword: false,
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        };
      } else {
        return {
          ...prev,
          changePassword: true,
        };
      }
    });

    
    if (formData.changePassword) {
      setShowCurrentPassword(false);
      setShowNewPassword(false);
      setShowConfirmPassword(false);
    }
  };

  return (
    <>
      <TitleHeader heading="Edit Profile " breadcrumbs={breadcrumbs} />

      <OverlayLoading isLoading={loading}>
        <div className="employee-profile">
          <div className="page-card-bg table-data-new">
            <div className="header">
              <div className="profile-image-container">
                <img
                  src={selectedImage || formData?.image}
                  alt="Profile"
                  className="profile-image"
                />

                <span onClick={() => inputRef.current.click()}>
                  <svg
                    width="12"
                    height="13"
                    viewBox="0 0 12 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.864962 9.91591L0.0302158 12.1419C-0.00183801 12.2276 -0.00855697 12.3206 0.0108616 12.41C0.0302802 12.4994 0.0750154 12.5813 0.139725 12.646C0.204434 12.7106 0.286382 12.7552 0.375782 12.7746C0.465183 12.7939 0.558256 12.7871 0.643888 12.7549L2.86924 11.9202C3.12395 11.8248 3.35529 11.676 3.54771 11.4838L9.99381 5.03767C9.99381 5.03767 9.76892 4.36364 9.09554 3.68962C8.42215 3.01623 7.74749 2.79135 7.74749 2.79135L1.30139 9.23744C1.10917 9.42987 0.960359 9.66121 0.864962 9.91591ZM8.6464 1.89244L9.52498 1.01386C9.68253 0.85631 9.8928 0.755937 10.1126 0.792783C10.422 0.843604 10.8953 0.99734 11.3412 1.44394C11.7878 1.89053 11.9416 2.36317 11.9924 2.67255C12.0292 2.89235 11.9288 3.10263 11.7713 3.26018L10.8921 4.13876C10.8921 4.13876 10.6678 3.46537 9.99381 2.79198C9.32042 2.11732 8.6464 1.89244 8.6464 1.89244Z"
                      fill="#01265D"
                    ></path>
                  </svg>
                  <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                    ref={inputRef}
                  />
                </span>
              </div>
            </div>

            <div className="form-data-main">
              <form onSubmit={submitForm}>
                <div className="page-card-bg data-page-big-height">
                  <div className="form-all-grid">
                    <div className="input-main-data">
                      <label>Name</label>
                      <input
                        type="text"
                        name="name"
                        onChange={handleFormChange}
                        value={formData?.name}
                      />
                      {formErrors?.name && (
                        <div className="error_message">{formErrors?.name}</div>
                      )}
                    </div>

                    <div className="input-main-data">
                      <label>Email</label>
                      <input
                        type="text"
                        name="email"
                        onChange={handleFormChange}
                        value={formData?.email}
                      />
                      {formErrors?.email && (
                        <div className="error_message">{formErrors?.email}</div>
                      )}
                    </div>
                  </div>

                  <div className="time-toggle select-all-type mb-4 d-flex gap-2 align-items-end">
                    <div
                      className={
                        formData?.changePassword
                          ? "toggle-switch on"
                          : "toggle-switch off"
                      }
                      onClick={handlePasswordToggle}
                    >
                      <div className="toggle-knob"></div>
                    </div>
                    <div>Change Password</div>
                  </div>
                  {formData?.changePassword && (
                    <div className="password-fields">
                      <div className="form-all-grid">
                        <div className="input-main-data">
                          <label>Old Password</label>
                          <div className="password-input-wrapper">
                            <input
                              type={showCurrentPassword ? "text" : "password"}
                              name="currentPassword"
                              onChange={handleFormChange}
                              autoComplete="off"
                              value={formData.currentPassword}
                            />
                            <button
                              type="button"
                              className="password-toggle"
                              onClick={() => togglePassword("current")}
                            >
                              {showCurrentPassword ? (
                                <EyeOpenIcon />
                                
                              ) : (
                                <EyeClosedIcon />
                              )}
                            </button>
                          </div>
                          {formErrors.currentPassword && (
                            <div className="error_message">
                              {formErrors.currentPassword}
                            </div>
                          )}
                        </div>

                        <div className="input-main-data">
                          <label>New Password</label>
                          <div className="password-input-wrapper">
                            <input
                              type={showNewPassword ? "text" : "password"}
                              name="newPassword"
                              onChange={handleFormChange}
                              autoComplete="new-password"
                              value={formData.newPassword}
                            />
                            <button
                              type="button"
                              className="password-toggle"
                              onClick={() => togglePassword("new")}
                            >
                              {showNewPassword ? (
                                <EyeOpenIcon />
                              ) : (
                                <EyeClosedIcon />
                              )}
                            </button>
                          </div>
                          {formErrors.newPassword && (
                            <div className="error_message">
                              {formErrors.newPassword}
                            </div>
                          )}
                        </div>

                        <div className="input-main-data">
                          <label>Confirm Password</label>
                          <div className="password-input-wrapper">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              name="confirmPassword"
                              onChange={handleFormChange}
                              autoComplete="new-password"
                              value={formData.confirmPassword}
                            />
                            <button
                              type="button"
                              className="password-toggle"
                              onClick={() => togglePassword("confirm")}
                            >
                              {showConfirmPassword ? (
                                <EyeOpenIcon />
                              ) : (
                                <EyeClosedIcon />
                              )}
                            </button>
                          </div>
                          {formErrors.confirmPassword && (
                            <div className="error_message">
                              {formErrors.confirmPassword}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="btn-form-send">
                  <button className="common-button" disabled={loading}>
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </OverlayLoading>
    </>
  );
};

export default Profile;
